import {
  Component, OnInit, Input, Output, EventEmitter, KeyValueChanges, KeyValueDiffer,
  KeyValueDiffers, OnDestroy, ViewChild, ChangeDetectionStrategy, HostListener, DoCheck, ElementRef, NgZone, ChangeDetectorRef
} from '@angular/core';
import { item } from '../items';
import { SettingsService } from '@scaffold/services/settings.service';
import { setting } from '../settings';
import { ItemsService } from '@scaffold/services/items.service';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { ItemModalComponent } from '../item-modal/item-modal.component';
import cloneDeep from 'lodash/cloneDeep';
import { TinyMCEOptions } from '@app/shared/tinymce_options';
import { FileModalComponent } from '@scaffold/dialogs/file-modal/file-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { GraphsService } from '@services/graphs.service';
import { LtiService } from '@services/lti.service';
import { HtmldocModalComponent } from '@scaffold/dialogs/htmldoc-modal/htmldoc-modal.component';
import { take, filter, takeUntil, map } from 'rxjs/operators';
import { CommentingService } from '../../services/commenting.service';
import { Subject, Subscription } from 'rxjs';
import { PropertiesService } from '../../services/properties.service';
import { NbDialogService, NbDialogRef, NbMenuItem, NbMenuService } from '@nebular/theme';
import { ScaffoldSidebarService } from '@services/scaffold-sidebar.service';
import { CommentSidebarComponent } from '@app/commenting/comment-sidebar/comment-sidebar.component';
import { OptionsComponent } from '../options/options.component';
import { EnvironmentService, InstanceDetails } from '../../../services/environment.service';
@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss', '../editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemsComponent implements OnInit, OnDestroy {
  instanceDetails: InstanceDetails;
  last_hovered;
  last_hovered_after;
  extra = [];
  columns = [];
  columnRefs = [];
  private _item: item;
  @Input('item')
  set item(value: item) {
    this._item = value;
    this.configureItem();
  }
  get item(): item {
    return this._item;
  }
  private _info: any;
  @Input('info')
  set info(value) {
    this._info = value;
    this.configureItem();
  }
  get info() {
    return this._info;
  }

  @Input() data: item;
  @Input() arr: item[];
  @Input() parents;
  @Input() undoService;
  @Input() toCreateItems: Array<any> = [];
  commentSubscription;
  commentUpdatesub;
  comments = {};
  render = true;
  debounce;
  public Editor: any;
  slides: string[] = ['https://c1.staticflickr.com/4/3854/14668986874_a852c156b1_b.jpg', 'https://c1.staticflickr.com/8/7142/6672213105_a059b7bdb9_b.jpg'];
  settings: setting;
  items_list: item[];
  options;
  elId = Math.floor(Math.random() * 500000);
  dialogRef: NbDialogRef<ItemModalComponent>;
  fileRef: NbDialogRef<FileModalComponent>;
  @Output() deleteItem = new EventEmitter<item>();
  @Output() addItem = new EventEmitter<item>();
  @Output() itemChanged = new EventEmitter<string>();
  selectedTab = 0;
  showEditor = false;
  private optionsDiffer: KeyValueDiffer<string, any>;
  @ViewChild('itemcontrols') toolbarButtons;
  __hostElement;
  @ViewChild('graph')
  set _hostElement(ref: ElementRef) {
    console.log('set host element', ref);
    this.__hostElement = ref;
    this.setUpdGraph();
  }
  get _hostElement() {
    return this.__hostElement;
  }
  editText = '';
  selectedStep: number;
  nextStep = 0;
  active = true;
  value;
  textdebounce;
  hostElement;
  values;
  width: 'auto';
  editor_options;
  movingsub: Subscription;
  propertiesUpdateSubscription: Subscription;
  propertiesSelected;
  get classes() {
    let classes = '';
    if (this.item.background_type === 'select') {
      if (this.item.background) {
        classes += this.item.background;
      }
      if (this.item.background) {
        classes += ' ' + this.item.alignment;
      }
    }
    return classes;
  }
  colors = ['#b5424a', '#68899e', '#fe9e22', '#70357f', '#eaf04a', '#d3b13c', '#71eea6', '#a294d0', '#ee71e4', '#95ba3b', '#696969', '#7d6342'];
  tools = [];

  $sub: Subject<boolean> = new Subject();
  item_menu: NbMenuItem[] = [];

  constructor(private cdr: ChangeDetectorRef,
    private settingsService: SettingsService,
    private itemsService: ItemsService,
    public dialog: NbDialogService,
    public movingItem: MoveItemService,
    public editor: TinyMCEOptions,
    private differs: KeyValueDiffers,
    private sanitizer: DomSanitizer,
    private graph: GraphsService,
    private _zone: NgZone,
    private LTIService: LtiService,
    private commentor: CommentingService,
    private properties: PropertiesService,
    private nbMenuService: NbMenuService,
    private commentSidebar: ScaffoldSidebarService,
    private sidebar: ScaffoldSidebarService,
    private environmentService: EnvironmentService) {
    const op = cloneDeep(editor.options);
    this.options = op;
    settingsService.getSettings().pipe(take(1)).subscribe(settings => this.settings = settings);
    itemsService.getItems().pipe(take(1)).subscribe(item_list => this.items_list = item_list);
  }

  selectFile(callback, fileFilter): void {
    const settings: any = {
      context: {
        data: {
          filter: fileFilter
        }
      }
    };
    console.log(fileFilter);
    this.fileRef = this.dialog.open(FileModalComponent, settings);

    this.fileRef.onClose.pipe(take(1)).subscribe(result => {
      console.log(result);
      if (result && typeof result !== 'string') {
        callback();
        this.update();
      }


    });
  }
  // ca6ac0a2-58ab-4f2a-9240-4ad7d52f4551 //23779dcbfa904fb17cc627080755b961
  delete(ite) {
    this.deleteItem.emit(ite);
  }

  deleteHandler(ite, arr) {
    const index = arr.indexOf(ite);
    arr.splice(index, 1);
    if (this.active) {
      this.itemChanged.emit('delete');
      this.update();
    }
  }
  addHandler(new_item, ite, arr) {
    const index = arr.indexOf(ite);
    arr.splice(index + 1, 0, new_item);
    if (this.active) {
      this.itemChanged.emit('add');
      this.update();
    }
  }

  stopBubble(event: Event) {
    console.log(event);
  }

  setPropertiesSelection(event, ite) {
    console.log(event);
    event.insideComponent = true;
    // if the event originated from a button or the icon in a button don't set the properties
    if (!event.target.matches('button') && !event.target.parentElement.matches('button') && !event.target.matches('nb-icon')) {
      // If the properties has already been set from a child element event, dont set it again
      if (!event.propertiesSet) {
         const config = {
            context: {
             propertiesItem: ite,
              parentView: this.info
            }
          };
          const _sidebar = this.sidebar.open(OptionsComponent, config);

        this.properties.setProperties(ite, this.info || {}, _sidebar);

        console.log('Set Properties', ite);
        this.propertiesSelected = true;
        // mark the properties as set in the event on the first child component to prevent parent component from
        //overriding the properties window
        // This is needed because using stopPropogation prevents the content menus in nebular from closing on click
        event.propertiesSet = true;
        this.propertiesUpdateSubscription = this.properties.propertiValueChange().pipe(takeUntil(this.$sub)).subscribe(i => {
          console.log('Item Change', event);
          this.itemChanged.emit('updated property');

        });
        this.update();
      }
    }
  }

  getIframURL(url) {

    if (url.match(/https*:\/\/./)) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
  }

  moveItem(ite, arr, copy) {
    console.log(arr);
    let index = -1;
    if (ite === 'cancel') {
      this.movingItem.setSelection(null);
    } else {
      const cur = this.movingItem.getSelection();
      if (ite) {
        index = arr.indexOf(ite);
      }
      if (cur) {
        const position = this.movingItem.getPosition();
        if (position) {
          console.log(position);
          position.arr.splice(position.ind, 1);
          if (position.arr !== arr || position.ind > index) {
            index++;
          }
        } else {
          index++;
        }
        arr.splice(index, 0, cur);
        this.movingItem.setSelection(null);
        if (this.active) {
          this.itemChanged.emit('move');
        }
        // this.editor.reInit()
      } else {
        console.log(copy);
        if (copy) {
          this.movingItem.setSelection(cloneDeep(ite));
          this.movingItem.setPosition(null, null);
        } else {
          this.movingItem.setSelection(ite);
          this.movingItem.setPosition(index, arr);
        }
        // arr.splice(index, 1)
      }
    }
    this.update();
  }
  stepChanged(e) {
    console.log(e);
    this.nextStep = e.selectedIndex;
    this.update();
  }

  stepLoaded() {
    this.selectedStep = this.nextStep;
  }
  setTab(e) {
    console.log(e);
  }
  addRow(ite) {
    ite.data.push({});
    console.log(ite);
    this.update();
  }
  deleteRow(row, arr) {
    arr.splice(arr.indexOf(row), 1);
    this.update();
  }
  redrawColumns() {
    this.columnRefs = [];
    this.columns = [];
    this.item.columns.forEach(col => {
      if (!this.columns.includes(col.label)) {
        this.columns.push(col.label);
        this.columnRefs.push(col.label);
      }
    });
    this.columns.push('Delete');
    this.update();
  }

  updateHeader(e, ite, param) {
    console.log(e);
    ite[param] = e.target.textContent;
  }

  editorChange() {
    if (this.textdebounce) {
      console.log('Clear Debounce');
      clearTimeout(this.textdebounce);

    }
    this.textdebounce = setTimeout(() => {
      console.log('after textdebounce');
      this.subChange('text');
    }, 500);

  }

  subChange(type?: string) {
    if (this.active) {
      this.itemChanged.emit(type);
    }
  }
  openDialog(event): void {
    this.stopBubble(event);
    //  this.movingItem.setPropertiesItem(null);
    const settings: any = {
      context: {
        data: { list: this.items_list, item: this.item, parents: this.parents, toCreate: this.toCreateItems },
      }
    };
    this.dialogRef = this.dialog.open(ItemModalComponent, settings);

    this.dialogRef.onClose.pipe(take(1)).subscribe(result => {
      if (result && (typeof result !== 'string' || result.length > 0)) {
        this.addItem.emit(result);
        this.update();
      }
    });
  }
  openRootDialog(event, list): void {
    this.stopBubble(event);
    const settings: any = {
      context: {
        data: { list: this.items_list, item: this.item, parents: this.parents, toCreate: this.toCreateItems },
      }
    };
    console.log(list);
    this.dialogRef = this.dialog.open(ItemModalComponent, settings);

    this.dialogRef.onClose.pipe(take(1)).subscribe(result => {
      if (result && (typeof result !== 'string' || result.length > 0) && this.active) {

        list.splice(0, 0, cloneDeep(result));
        if (this.toCreateItems && this.toCreateItems.indexOf(result) >= 0) {
          console.log('Setting used');
          result.used = true;
        }
        this.itemChanged.emit('move');
        this.update();
      }
    });
  }
  ngDoCheck(): void {
    if (this.optionsDiffer) {
      const changes = this.optionsDiffer.diff(this.item);
      if (changes) {
        changes.forEachItem(i => {
          if (i.key === 'block_editor') {
            this.options['inline'] = !this.item['block_editor'];
            console.log(this.options);
            this.redrawTinyMce();

          }
          if (i.previousValue && i.currentValue !== i.previousValue && this.active) {
            this.sendUpdate(i.key);
          }
        });
        this.update();
      }
    }
  }

  sendUpdate(send) {
    if (this.debounce) {
      console.log('Clear Debounce');
      clearTimeout(this.debounce);

    }

    this.debounce = setTimeout(() => {
      console.log('after debounce');
      this.itemChanged.emit(send);
      this.update();
    }, 1000);

  }

  setup(editor) {
    console.log('SETUP');
    const $this = this;
    const tool_buttons = [];

    this.tools.forEach(tool => {
      try {
        console.log(tool);
        if (tool.data.location) {
          const button = tool.data.location.find(t => t.location_type === 'editor_button');
          tool_buttons.push({
            text: button.text || tool.title,
            icon: button.icon_url || false,
            onclick: function () {
              $this._zone.run(() => {
                $this.launch.call($this, tool, button, editor);
              });
              // editor.insertContent('&nbsp;<strong>Menu item 1 text inserted here!</strong>&nbsp;');
            }
          });
        }
      } catch (e) {

      }
    });

    console.log(tool_buttons);
    if (tool_buttons.length > 0) {
      editor.addButton('external', {
        type: 'menubutton',
        text: 'External Tools',
        icon: false,
        menu: tool_buttons
      });

    }
    editor.on('ObjectResized', function (e) {
      if (e.target.nodeName === 'IMG') {

        const selectedImage = editor.selection.getNode();
        console.log(selectedImage);
        editor.dom.setStyle(selectedImage, 'width', e.width);
        editor.dom.setStyle(selectedImage, 'height', null);

        selectedImage.removeAttribute('width');
        selectedImage.removeAttribute('height');
      }
    });
    editor.on('ObjectSelected', function (e) {
      if (e.target.nodeName === 'IMG') {
        const width = e.target.getAttribute('width');
        const height = e.target.getAttribute('height');
        const selectedImage: Element = editor.selection.getNode();
        console.log(width, height, selectedImage);
        if (width && width.length > 0) {
          editor.dom.setStyle(selectedImage, 'width', width + 'px');
          selectedImage.removeAttribute('width');
        }
        if (height && height.length > 0) {
          editor.dom.setStyle(selectedImage, 'height', height + 'px');
          selectedImage.removeAttribute('height');
        }

      }
    });
    editor.addMenuItem('formatScrub', {
      text: 'Remove Layout',
      context: 'format',
      onclick: function () {
        const html = editor.getContent();
        const ite = document.createElement('div');
        ite.innerHTML = html;
        const ids = ite.querySelectorAll('div');
        ids.forEach(i => unwrap(i));
        const spans = ite.querySelectorAll('span');
        spans.forEach(i => unwrap(i));
        ite.querySelectorAll('[style]')
          .forEach(el => el.removeAttribute('style'));
        editor.undoManager.add();
        editor.setContent(ite.innerHTML);
        editor.focus();
        editor.nodeChanged();
        function unwrap(el) {
          // get the element's parent node
          const parent = el.parentNode;

          // move all children out of the element
          while (el.firstChild) { parent.insertBefore(el.firstChild, el); }

          // remove the empty element
          parent.removeChild(el);
        }
      }
    });
    console.log(editor);
  }

  launch(tool, button?, editor?) {
    const info = this.info;
    //  this.src = "https://tuc6cdlir6.execute-api.us-east-2.amazonaws.com/dev/"
    const settings: any = {
      context: {
        data: {
          target_z: 65538,
          tool: tool,
          button: button,
          info: info
        }
      }
    };
    const dialogRef = this.dialog.open(HtmldocModalComponent, settings);
    dialogRef.onClose.pipe(take(1)).subscribe(message => {
      if (message) {
        let result;
        if (message.id === this.info.id) {
          switch (message.return_type) {
            case 'iframe':
              result = `<div style="width:60%;margin: auto;"><div style="position: relative;display: block;height: 0;padding: 0;padding-bottom: 0px;overflow: hidden;padding-bottom: 56.25%;">
    <iframe style="position: absolute;top: 0;bottom: 0;left: 0;width: 100%;height: 100%;border: 0;" src="${message.url}" allowfullscreen></iframe>
</div></div>`;
              break;
            case 'oembed':
              break;
            case 'lti_launch_url':
              result = `<div><iframe title="${message.title}" data-integration="${message.lms}" data-lti-launch="${encodeURIComponent(JSON.stringify(message))}" src="/external/${message.course}/display?display=borderless&amp;url=${message.url}&lms=${message.lms}" style="width:${message.width === 'auto' ? message.width : message.width + 'px'};height:${message.height === 'auto' ? message.height : message.height + 'px'};" allowfullscreen="allowfullscreen" webkitallowfullscreen="webkitallowfullscreen" mozallowfullscreen="mozallowfullscreen" allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"></iframe > </div>`;
              break;
            case 'url':
              result = `<a title="${message.text}" href="${message.url}" target="${message.target || '_blank'}">${message.text}</a>`;
              break;
            case 'image_url':
              result = `<img title="${message.title}" src="${message.url}"/>`;
              break;
            default:
              console.log('No matching return type');
          }
        }
        editor.undoManager.transact(function () {
          editor.insertContent(result);
        });
        this.editorChange();
        editor.focus();
        editor.selection.setCursorLocation();
        editor.nodeChanged();
      }
    });

  }

  setButtons() {
    this.item_menu = [{
      title: 'Move',
      hidden: this.movingItem.selectedItem === this.item,
      data: {
        function: 'moveItem',
        params: [this.item, this.arr]
      }
    },
    {
      title: 'Cancel Move',
      hidden: this.movingItem.selectedItem !== this.item,
      data: {
        function: 'moveItem',
        params: ['cancel']
      }
    },

    {
      title: 'Copy',
      hidden: this.movingItem.selectedItem === this.item,
      data: {
        function: 'moveItem',
        params: [this.item, this.arr, true]
      }
    },

    {
      title: 'Delete',
      data: {
        function: 'delete',
        params: [this.item]
      }
    }];
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    // this.editor.reInit();
    // this.render = false;
    if (this.$sub) {
      this.$sub.next(true);
      this.$sub.complete();
    }
  }
  ngOnInit () {
    this.environmentService.getInstanceDetails().subscribe(det => this.instanceDetails = det);
    this.setButtons();
    this.movingItem.moveSelection().pipe(takeUntil(this.$sub)).subscribe(ite => {
      this.setButtons();
    });
    this.nbMenuService.onItemClick()
      .pipe(
        takeUntil(this.$sub),
        filter(({ tag }) => tag === 'scaffold-item-edit-menu-' + this.elId),
        map(({ item }) => item)
      )
      .subscribe(menu => {
        console.log(menu);
        try {
          this[menu.data.function](menu.data.params[0], menu.data.params[1], menu.data.params[2]);
        } catch (e) {
          console.log(e);
        }
        // this.execute(menu.item.data)
      });

    this.properties.watchProperties().pipe(takeUntil(this.$sub)).subscribe(i => {
      if (this.item !== i) {
        if (this.propertiesUpdateSubscription) {
          console.log('unsubscibe', this.item.type);
          this.propertiesUpdateSubscription.unsubscribe();
          this.propertiesUpdateSubscription = null;
          this.update();
          this.propertiesSelected = false;
        }
      }
    });
    this.commentor.watchActive().pipe(takeUntil(this.$sub)).subscribe(i => {
      this.update();
    });


  }

  configureItem() {
    if (this.item?.type === 'link' && !this.item.hasOwnProperty('content')) {
      this.item.content = [];
    }
    console.log('CONFIG ITEM', !this.item || !this.info);
    if (!this.item || !this.info) { return; }
    this.options['inline'] = !this.item['block_editor'];
    this.optionsDiffer = this.differs.find(this.item).create();
    if (this.item.type === 'heading') {
      this.editText = this.item.text;
    }
    // add an object in to hold extra infromation about the columns
    if ((this.item.type === 'row' || this.item.type === 'flex') && this.item.content && this.item.content > 0) {
      this.extra = [];
      this.item.content.forEach(c => {
        this.extra.push({});
      });

    }
    if (!this.item.related_comments) {
      this.item.related_comments = [];
    }
    console.log('COMMENTS', this.info.comments, this.item.related_comments);
    if (this.info.comments && this.item.related_comments) {
      this.comments[this.info.name] = this.info.comments[this.info.name]
        .filter(com => this.item.related_comments.includes(com.id.toString()) ||
          (com.response_to && this.item.related_comments.includes(com.response_to.toString())));
      this.info.info.claimed_comments = this.info.info.claimed_comments || [];
      this.info.info.claimed_comments = [...new Set([...this.info.info.claimed_comments, ...this.item.related_comments])];
    } else {
      this.comments[this.info.name] = [];
    }
    this.commentSubscription = this.commentor.getCommentsUpdates().pipe(takeUntil(this.$sub)).subscribe(comments => {
      if (comments[this.info.id] && comments[this.info.id][this.info.name]) {
        this.comments[this.info.name] = comments[this.info.id][this.info.name]
          .filter(com => this.item.related_comments.includes(com.id) ||
            (com.response_to && this.item.related_comments.includes(com.response_to.toString())));
        this.info.info.claimed_comments = this.info.info.claimed_comments || [];
        this.info.info.claimed_comments = [...new Set([...this.info.info.claimed_comments, ...this.item.related_comments])];
        this.update();
      }
    });
    if (this.info.info) {
      if (this.item.type === 'text' || this.item.type === 'lti_tool') {
        console.log('Is text or tool');
        this.LTIService.getToolList().pipe(take(1)).subscribe(tools => {
          try {
            console.log(tools);
            console.log(this.info);
            let tool_array = [];
            if (tools.id) {
              tool_array.push(tools);
            } else if (tools.listItems) {
              tool_array = tools.listItems;
            } else if (tools.push) {
              tool_array = tools;
            }
            this.tools = tool_array.filter(tool => tool.institution_id === this.info.info.institution_id);
            if (this.item.type === 'text') {
              console.log('needs editor options');
              const options = cloneDeep(this.editor.options);
              options.setup = this.setup.bind(this);
              this.editor_options = options;
              console.log(this.editor_options);
              this.itemChanged.emit('init');
              this.update();
            }
            this.update();
          } catch (e) {
            console.log(e);
          }
        });
      }
    } else {
      if (this.item.type === 'text') {
        console.log('needs editor options');
        const options = cloneDeep(this.editor.options);
        options.setup = this.setup.bind(this);
        this.editor_options = options;
        console.log(this.editor_options);
        this.itemChanged.emit('init');
        this.update();
      }
    }
    this.update();

  }

  setUpdGraph() {
    if (this.item && this.item.type === 'data_visuals' && this.item.data_items) {
      this.hostElement = this._hostElement.nativeElement;
      this.values = this.item.data_items.map(v => {
        console.log(v.value);
        if (!v.value) {
          v.value = Math.floor(Math.random() * 100);
        }
        return parseInt(v.value, 10);
      });
      this.graph.generatePie(this.hostElement, this.values, this.item);
      this.update();
    }

  }
  stopProp(event: Event) {
    event.stopPropagation();
  }

  dateChange(obj, param, value) {
    console.log(obj, param, value);


  }
  columnData(i) {
    if (typeof this.extra[i] === 'undefined') {
      this.extra[i] = {};
    }
    return this.extra[i];
  }

  toURL(url) {
    if (url) {
      if (url.match(/^https*:\/\//)) {
        return url;
      } else {
        return 'https://' + url;
      }
    }
    return null;
  }
  redrawTinyMce() {
    setTimeout(() => {
      this.render = false;
      setTimeout(() => {
        this.render = true;
      }, 10);
    });
  }

  calcStyle() {
    let style = '';
    if (this.item.width) {
      style += this.caclWidth();
    }
    try {
      if (this.item.background_type === 'data' && this.item.value) {
        let index;
        if (typeof this.item.value === 'string') {
          if (!this.item.value.match(/\D/)) {
            index = parseInt(this.item.value, 10);
          } else {
            index = this.item.value.charCodeAt(0) - 97;
          }
        }
        if (typeof this.item.value === 'number') {
          index = Math.floor(this.item.value);
        }
        if (index && typeof index === 'number') {
          index = index % 19;
          const color = this.colors[index];
          style += 'background-color:' + color + ';';
          //  style += "color:" + this.calculateTextColor(color) + ";"
        }
      } else if (this.item.background_type === 'manual') {
        style += 'background-color:' + this.item.background_color + ';';
        //  style += "color:" + this.calculateTextColor(this.item.background_color) + ";"
      }
    } catch (e) {
      console.log(e);
    }
    if (this.item.border) {
      style += 'border:' + this.item.border + ';';
    }
    if (this.item.text_color) {
      style += 'color:' + this.item.text_color + ';';
    }
    if (this.item.is_bold) {
      style += 'font-weight:700;';
    }
    if (this.item.is_italic) {
      style += 'font-style:italic;';
    }
    if (this.item.radius) {
      style += `border-radius:${this.item.radius}${this.item.radius_type || 'px'};`;
    }
    return style;
  }
  caclWidth() {
    const w = 'width:' + this.item.width + ';';
    return w;
  }


  calculateTextColor(color) {
    const c = color.substring(1);      // strip #
    const rgb = parseInt(c, 16);   // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff;  // extract red
    const g = (rgb >> 8) & 0xff;  // extract green
    const b = (rgb >> 0) & 0xff;  // extract blue

    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    return luma < 128 ? '#fff' : '#000';
  }
  getCommentCount(name) {
    let toReturn = 0;
    if (this.comments && this.comments[name] && this.comments[name].length) {
      if (this.comments[name].length === 0) {
        return 0;
      }
      // console.log(this.comments[name]);
      const not_resolved = [];

      this.comments[name].forEach(com => {
        if (!com.resolved) {
          not_resolved.push(com.id);
        }
      });
      const unresolved = this.comments[name].filter(com => !com.resolved && (!com.response_to || not_resolved.includes(com.response_to)));
      toReturn = unresolved.length;
    }

    return toReturn;

  }

  getCommentClass(key?) {
    let toreturn;
    const noComments = 'far fa-comment';
    const oneComment = 'fas fa-comment';
    const multipleComments = 'fas fa-comments';
    if (this.getCommentCount(this.info.name) > 0) {
      if (this.comments[this.info.name].length === 1) {
        toreturn = oneComment;
      } else {
        toreturn = multipleComments;
      }
    } else {
      toreturn = noComments;
    }
    if (key) {
      const parts = toreturn.split(/\s/);
      const obj = {
        pack: parts[0],
        icon: parts[1].replace(/fa-/, '')
      };
      return obj[key];
    }
    return toreturn;
  }
  getSelectionText() {
    let text = '';
    if (window.getSelection) {
      text = window.getSelection().toString();

    }
    return text;
  }
  setActiveComments(e: Event) {
    console.log(e);
    console.log(this.comments);
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
    const selection = this.getSelectionText();
    console.log(selection);
    /* if (this.item.name)
       this.comments = this.commentor.getCommentHolder(this.info);*/
    console.log(this.comments);
    console.log(this.item);
    const subItem = new Subject();
    if (!this.item.related_comments) {
      this.item.related_comments = [];
    }
    subItem.asObservable().subscribe(ite => {
      const comment = ite[0];
      if (!comment.response_to) {
        this.item.related_comments.push(comment.id);
      }
      this.itemChanged.emit('comment');


    });
    const config: any = {
      context: {
        item: this.info.name,
        info: this.info,
        label: this.settings[this.item.type].Name,
        subItem: subItem,
        details: { filter: this.item.related_comments, item: this.item }
      }
    };
    const _sidebar = this.commentSidebar.open(CommentSidebarComponent, config);

  }
  onPaste(event) {
    console.log(event);
    event.preventDefault();
    const clipboardData = event.clipboardData || event.originalEvent.clipboardData;
    const pastedText = clipboardData.getData('text');
    console.log(pastedText);
    this.item.text = pastedText;
  }

  isActive() {
    return (this.commentor.item && this.commentor.item === this.item);
  }

  update() {
    this.cdr.markForCheck();

  }

}
